import { store } from '@store/store'
import { notificationActionCreators } from '@storeOld/reducers/notification'
import { put, select } from 'redux-saga/effects'

import { authSelector } from '@/hooks/useAuth'
import type { AuthState } from '@/types'
import { upgradeModal } from '../upgradeModal'

/**
 * Limit-reached toast with an "Upgrade" link, carrying the upstream message.
 * Unlike alert(), it does not open the upsell modal on its own — the user was
 * doing something else (duplicating, unarchiving, moving) and a modal on top
 * of that would be a hijack, so the upsell stays one click away.
 */
export function* upgradeToast(text: string) {
  const { planId }: AuthState = yield select(authSelector)

  const modal = upgradeModal(planId, 'projects')

  yield put(
    notificationActionCreators.setCustomNotification({
      type: 'coral',
      text,
      toastContainerId: 'secondary',
      // No next plan (Team, Agency) — nothing to link the toast to.
      ...(modal && {
        actionText: 'Upgrade',
        callback: () => store.dispatch(modal),
      }),
    })
  )
}
